import {
  ADD_PATIENT_FAILURE,
  ADD_PATIENT_REQUEST,
  ADD_PATIENT_SUCCESS,
  DELETE_PATIENT_FAILURE,
  DELETE_PATIENT_REQUEST,
  DELETE_PATIENT_SUCCESS,
  FETCH_ADMISSION_PATIENTS_FAILURE,
  FETCH_ADMISSION_PATIENTS_REQUEST,
  FETCH_ADMISSION_PATIENTS_SUCCESS,
  FETCH_ALL_LIST_PATIENTS_FAILURE,
  FETCH_ALL_LIST_PATIENTS_REQUEST,
  FETCH_ALL_LIST_PATIENTS_SUCCESS,
  FETCH_LIST_PATIENTS_FAILURE,
  FETCH_LIST_PATIENTS_REQUEST,
  FETCH_LIST_PATIENTS_SUCCESS,
  FETCH_PATIENT_FAILURE,
  FETCH_PATIENT_REQUEST,
  FETCH_PATIENT_SUCCESS,
  HISTORY_PATIENTS_FAILURE,
  HISTORY_PATIENTS_REQUEST,
  HISTORY_PATIENTS_SUCCESS,
  RESET_CURRENT_PATIENT,
  UPDATE_PATIENT_FAILURE,
  UPDATE_PATIENT_REQUEST,
  UPDATE_PATIENT_SUCCESS,
} from "./patientType";

export const fetchPatients = (pageNo) => ({
  type: FETCH_LIST_PATIENTS_REQUEST,
  payload: pageNo,
});

export const fetchPatientsSuccess = (patients) => ({
  type: FETCH_LIST_PATIENTS_SUCCESS,
  payload: { patients },
});

export const fetchPatientsFailure = (error) => ({
  type: FETCH_LIST_PATIENTS_FAILURE,
  payload: { error },
});
export const fetchAllPatients = () => ({
  type: FETCH_ALL_LIST_PATIENTS_REQUEST,

});

export const fetchAllPatientsSuccess = (patients) => ({
  type: FETCH_ALL_LIST_PATIENTS_SUCCESS,
  payload: { patients },
});

export const fetchAllPatientsFailure = (error) => ({
  type: FETCH_ALL_LIST_PATIENTS_FAILURE,
  payload: { error },
});

export const fetchAdmissionPatients = (params) => ({
  type: FETCH_ADMISSION_PATIENTS_REQUEST,
  payload: params,
});

export const fetchAdmissionPatientsSuccess = (patients) => ({
  type: FETCH_ADMISSION_PATIENTS_SUCCESS,
  payload: { patients },
});

export const fetchAdmissionPatientsFailure = (error) => ({
  type: FETCH_ADMISSION_PATIENTS_FAILURE,
  payload: { error },
});
export const fetchHistoryPatients = (id) => ({
  type: HISTORY_PATIENTS_REQUEST,
  payload: id 
});

export const fetchHistoryPatientsSuccess = (patients) => ({
  type: HISTORY_PATIENTS_SUCCESS,
  payload: { patients },
});

export const fetchHistoryPatientsFailure = (error) => ({
  type: HISTORY_PATIENTS_FAILURE,
  payload: { error },
});

// View single patient
export const fetchPatient = (patientId) => ({
  type: FETCH_PATIENT_REQUEST,
  payload: { patientId },
});

export const fetchPatientSuccess = (patient) => {
  
  return {
    type: FETCH_PATIENT_SUCCESS,
    payload: { patient },
  };
};

export const fetchPatientFailure = (error) => ({
  type: FETCH_PATIENT_FAILURE,
  payload: { error },
});

// Add patient
export const addPatient = (patientData) => ({
  type: ADD_PATIENT_REQUEST,
  payload: { patientData },
});

export const addPatientSuccess = (patient) => ({
  type: ADD_PATIENT_SUCCESS,
  payload: { patient },
});

export const addPatientFailure = (error) => ({
  type: ADD_PATIENT_FAILURE,
  payload: { error },
});

// Edit patient
export const updatePatient = (patientId, patientData) => ({
  type: UPDATE_PATIENT_REQUEST,
  payload: { patientId, patientData },
});

export const updatePatientSuccess = (patient) => ({
  type: UPDATE_PATIENT_SUCCESS,
  payload: { patient },
});

export const updatePatientFailure = (error) => ({
  type: UPDATE_PATIENT_FAILURE,
  payload: { error },
});

// Delete patient
export const deletePatient = (patientId) => ({
  type: DELETE_PATIENT_REQUEST,
  payload: { patientId },
});

export const deletePatientSuccess = (patientId) => ({
  type: DELETE_PATIENT_SUCCESS,
  payload: { patientId },
});

export const deletePatientFailure = (error) => ({
  type: DELETE_PATIENT_FAILURE,
  payload: { error },
});

// Reset current patient
export const resetCurrentPatient = () => ({
  type: RESET_CURRENT_PATIENT,
});
